import LTR from "@brand-icons/ploom/package-shopping/package-shopping-ltr.svg";
import RTL from "@brand-icons/ploom/package-shopping/package-shopping-rtl.svg";

import { iconFactory } from "../iconFactory";

export const PackageShoppingIcon = iconFactory("PackageShoppingIcon", LTR, RTL);
